"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetManager = exports.PresetManagerEventTypes = void 0;
var preact_1 = require("preact");
var preset_item_1 = require("./preset-item");
var events_manager_1 = require("./events-manager");
var ui_player_adapter_1 = require("./ui-player-adapter");
var presets_utils_1 = require("./presets-utils");
var contrib_utils_1 = require("./contrib-utils");
var PresetManagerEventTypes;
(function (PresetManagerEventTypes) {
    PresetManagerEventTypes["PresetResizeEvent"] = "PresetResizeEvent";
    PresetManagerEventTypes["VideoResizeEvent"] = "VideoResizeEvent";
})(PresetManagerEventTypes = exports.PresetManagerEventTypes || (exports.PresetManagerEventTypes = {}));
var acceptableTypes = ['PlayerArea'];
var defaultPresetConfig = {
    presetAreasMapping: {
        Playback: {
            PlayerArea: 'PlayerArea'
        },
        Live: {
            PlayerArea: 'PlayerArea'
        }
    }
};
var PresetManager = /** @class */ (function () {
    function PresetManager(options) {
        var _this = this;
        this._events = new events_manager_1.EventsManager();
        this._isLocked = false;
        this._items = [];
        this._pendingItems = [];
        this._registerToPlayer = function (player) {
            player.addEventListener(KalturaPlayer.ui.EventType.UI_PRESET_RESIZE, _this._notifyUIPresetResize);
            player.addEventListener(KalturaPlayer.ui.EventType.VIDEO_RESIZE, _this._notifyVideoResize);
        };
        this._notifyVideoResize = function () {
            _this._events.emit({
                type: PresetManagerEventTypes.VideoResizeEvent
            });
        };
        this._notifyUIPresetResize = function () {
            _this._events.emit({
                type: PresetManagerEventTypes.PresetResizeEvent
            });
        };
        this._unregisterToPlayer = function (player) {
            player.removeEventListener(KalturaPlayer.ui.EventType.UI_PRESET_RESIZE, _this._notifyUIPresetResize);
            player.removeEventListener(KalturaPlayer.ui.EventType.VIDEO_RESIZE, _this._notifyVideoResize);
        };
        this.on = this._events.on.bind(this._events);
        this.off = this._events.off.bind(this._events);
        this._options = options;
        this._presetConfig = (0, contrib_utils_1.getContribConfig)(this._options.kalturaPlayer, 'ui.preset', defaultPresetConfig, {
            explicitMerge: ['presetAreasMapping']
        });
        var groupedPresets = presets_utils_1.PresetsUtils.groupPresetAreasByType({
            presetAreasMapping: this._presetConfig.presetAreasMapping,
            acceptableTypes: acceptableTypes
        });
        this.add({
            label: 'preset-manager',
            presetAreas: groupedPresets['PlayerArea'],
            renderChild: function () { return (0, preact_1.h)(ui_player_adapter_1.UIPlayerAdapter, { onMount: _this._registerToPlayer, onUnmount: _this._unregisterToPlayer }); }
        });
    }
    PresetManager.prototype.add = function (data) {
        if (this._isLocked) {
            console.warn("cannot add new preset items once player completed its' setup phase");
            // @ts-ignore
            return null;
        }
        var component = new preset_item_1.PresetItem({
            kalturaPlayer: this._options.kalturaPlayer,
            data: data
        });
        this._pendingItems.push(component);
    };
    PresetManager.prototype.lockManager = function () {
        this._isLocked = true;
    };
    PresetManager.prototype.registerComponents = function () {
        var configs = [];
        this._pendingItems.forEach(function (item) {
            configs = __spreadArray(__spreadArray([], configs, true), item.playerConfig, true);
        });
        this._items = __spreadArray(__spreadArray([], this._items, true), this._pendingItems, true);
        this._pendingItems = [];
        return configs.filter(Boolean);
    };
    return PresetManager;
}());
exports.PresetManager = PresetManager;
//# sourceMappingURL=preset-manager.js.map